import React, { FC } from 'react'

import { IconStarOutlineProps } from './IconStarOutline.types'
import * as Styled from './styles/IconStarOutline.style'

import { nonThemeableRules } from '../../ruleSet'

const IconStarOutline: FC<IconStarOutlineProps> = ({
  size = nonThemeableRules.defaultSize as number as IconStarOutlineProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconStarOutlineProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M19.975 7.337A.512.512 0 0 0 19.5 7h-6.85L10.475.35A.484.484 0 0 0 10 0a.5.5 0 0 0-.475.337L7.225 7H.5c-.213 0-.4.137-.475.325a.487.487 0 0 0 .15.55L5.55 12.4l-2.175 6.95c-.063.2.012.425.188.55a.5.5 0 0 0 .287.1c.1 0 .212-.038.3-.1L10 15.65l5.85 4.25a.507.507 0 0 0 .588 0 .487.487 0 0 0 .175-.563l-2.3-6.937L19.8 7.887a.505.505 0 0 0 .175-.55Zm-6.55 4.513a.5.5 0 0 0-.163.537l1.913 5.788-4.875-3.55a.507.507 0 0 0-.587 0L4.787 18.2l1.826-5.825c.062-.188 0-.4-.15-.538L1.875 8h5.713a.51.51 0 0 0 .474-.337l1.926-5.588 1.825 5.588c.062.2.262.35.474.35H18.1l-4.675 3.837Z'
          fill='#666'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconStarOutline
